{
  "partnerships": {
    "title": "Asociaciones",
    "empty": "No hay asociaciones",
    "leased_to": "Renta de Thiamis",
    "shared_to": "Compartido con Thiamis",
    "shared_devices": "Dispositivos compartidos",
    "create_new": "Crear Asociación",
    "filter_input": "Filtrar asociaciones...",
    "empty_list": "No hay asociaciones",
    "edit_metadata_title": "Editar metadatos de la asociación",
    "add_partnership_help": "Elija una organización existente o ingrese un ID de cliente externo (ej. AC334455)",
    "metadata": {
      "ref": "Referencia"
    }
  }
}
